const spectrumArticles = [
  {
    title: "Homecoming Bingo",
    author: "Suhani Arora",
    articleLink: "https://www.columbiaspectator.com/spectrum/2025/10/13/homecoming-bingo/",
    image: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/2HKVDSQ6FNGMNA32SBCNYGVPQU.jpg"
  },
  {
    title: "Homecoming isn’t your vibe? Follow Spectrum’s itinerary for a cute alternative.",
    author: "Alexandra Sepe and Tegan Wang",
    articleLink: "https://www.columbiaspectator.com/spectrum/2025/10/14/homecoming-isnt-your-vibe-follow-spectrums-itinerary-for-a-cute-alternative/",
    image: "https://www.columbiaspectator.com/resizer/v2/ELNCGBVCOFHDNKGXUJZVSP32WU.jpg?auth=4d5e1759300b8c8fa69c486b42f75d3a47155194c3811b18d59ee1f4d8cb30d2"
  },
  {
    title: "Here’s what inevitably happens at Homecoming",
    author: "Jessica Singh",
    articleLink: "https://www.columbiaspectator.com/spectrum/2025/10/15/heres-what-inevitably-happens-at-homecoming/",
    image: "https://www.columbiaspectator.com/resizer/v2/XJ6IDUU2EREZLCQAJCP7EAWZGE.JPG?auth=fe7f72165e6ed99b311f5ed41ff82386044c6cdb11d5aa047a91b0588cb77562"
  },
  {
    title: "Five go-to Homecoming outfits",
    author: "Sophia Li",
    articleLink: "https://www.columbiaspectator.com/spectrum/2025/10/14/five-go-to-homecoming-outfits/",
    image: "https://www.columbiaspectator.com/resizer/v2/D6XMPZWZIFF2TOZGLPQ3COXA3I.png?auth=11120308ff13d412992b8bcabb1fc57dfaea289def655d92d318803cf850f095"
  },
  {
    title: "’Twas the night before Homecoming",
    author: "Parini Rao and Laura Celadon",
    articleLink: "https://www.columbiaspectator.com/spectrum/2025/10/15/twas-the-night-before-homecoming/",
    image: "https://www.columbiaspectator.com/resizer/v2/VVD36YIJA5G7FIGRUO3RMDO4IU.jpeg?auth=02623e7752679424a40a61f54e1e6dee9fa181fe543f63c17ee289daaabfe580"
  }
];
export default spectrumArticles;